/* ==========================================================================
   Play Watches — Teaser page
   Klaviyo Client API email capture
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-pw-root]');
  if (!root) return;

  var KLAVIYO_KEY = root.getAttribute('data-klaviyo-key');
  var KLAVIYO_LIST = root.getAttribute('data-klaviyo-list');

  var form = root.querySelector('[data-pw-form]');
  var emailInput = root.querySelector('[data-pw-email-input]');
  var submitBtn = root.querySelector('[data-pw-submit]');
  var successEl = root.querySelector('[data-pw-success]');
  var successEmailEl = root.querySelector('[data-pw-success-email]');
  var errorEl = root.querySelector('[data-pw-error]');

  if (!form || !emailInput || !submitBtn) return;

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.classList.add('is-visible');
  }

  function hideError() {
    if (!errorEl) return;
    errorEl.classList.remove('is-visible');
  }

  function showSuccess(email) {
    if (successEmailEl) successEmailEl.textContent = email;
    form.style.display = 'none';
    if (errorEl) errorEl.style.display = 'none';
    if (successEl) successEl.classList.add('is-visible');
    try { localStorage.setItem('pw_subscribed', '1'); } catch (e) {}
  }

  function submitToKlaviyo(email) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_KEY);
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Coming Soon Page',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: KLAVIYO_LIST }
          }
        }
      }
    };
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.status === 202) return { ok: true };
      return res.json().then(function (body) {
        return { ok: false, status: res.status, body: body };
      }).catch(function () {
        return { ok: false, status: res.status };
      });
    });
  }

  // Returning visitor — go straight to success
  try {
    if (localStorage.getItem('pw_subscribed') === '1') {
      form.style.display = 'none';
      if (successEl) successEl.classList.add('is-visible');
    }
  } catch (e) {}

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    hideError();

    var email = (emailInput.value || '').trim();
    if (!email) { showError('Please enter your email.'); return; }
    if (!isValidEmail(email)) { showError('That email looks off — give it another go.'); return; }

    submitBtn.disabled = true;
    var originalLabel = submitBtn.textContent;
    submitBtn.textContent = 'SENDING…';

    submitToKlaviyo(email).then(function (result) {
      if (result.ok) {
        showSuccess(email);
      } else {
        var msg = 'Something went wrong. Please try again.';
        if (result.body && result.body.errors && result.body.errors[0]) {
          var detail = result.body.errors[0].detail || '';
          if (/email/i.test(detail)) msg = 'That email was rejected — please check it.';
        }
        showError(msg);
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
      }
    }).catch(function () {
      showError('Network error. Check your connection and try again.');
      submitBtn.disabled = false;
      submitBtn.textContent = originalLabel;
    });
  });
})();
